import React, { useState } from 'react'
import styles from './change_password.module.css'
import getStringsBasedLang from '../../strings/get_strings'
import LoginCustomInput from '../login/LoginCustomInput'
import { DEFAULT_COLOR} from '../../utils'
import { useNavigate } from 'react-router-dom'
import Layout from '../layout/layout'
import { createData } from '../../api/http-service'
import UseErrorHandling, { showToastError, showToastSuccess } from '../../hook/UseErrorHandling'

export default function ChangePassword(props) {


    const [isLoading, setIsLoading] = useState(false)
    const [passValue, setPassValue] = useState()
    const [passHelperText, setPassHelperText] = useState('')
    const [newPassHelperText, setNewPassHelperText] = useState('')
    const [newPassValue, setNewPassValue] = useState('')
    const [confirmPassValue, setConfirmPassValue] = useState('')
    let token = localStorage.getItem('token')
    let navigate = useNavigate()
    const handleErrorApi = UseErrorHandling();

    const passOnchangeHandler = (e) => {
        const pass = e.target.value.trim()
        setPassValue(pass)

       /*  if (pass.length === 0) {
            setPassHelperText('')
            setPassValue(null)
        }
        else if (pass.length < 8) {
            setPassHelperText(strings.login_passError)
            setPassValue(null)
        } else {
            setPassHelperText('')
        } */
    }

    const newPassOnchangeHandler = (e) => {
        const pass = e.target.value.trim()
        setNewPassValue(pass)

      /*   if (pass.length === 0) {
            setNewPassHelperText('')
            setNewPassValue(null)
        }
        else if (pass.length < 8) {
            setNewPassHelperText(strings.login_passError)
            setNewPassValue(null)
        } else {
            setNewPassHelperText('')
        } */
    }

    const enterKeyHadnler = (e) => {
        if (e.key === "Enter" && !isLoading)
            confirmHandler()
    }

    const confirmHandler = () => {
        if (!passValue) {
            showToastError(getStringsBasedLang("confirmPass_validPass"))
            return
        }
        if (newPassValue) {
            if (newPassValue === confirmPassValue) {
                setIsLoading(true)
                createData("user/password/change", {
                    "token": token,
                    "old_password": passValue,
                    "new_password": newPassValue
                })
                    .then((changePasswordResult) => {
                      if (!changePasswordResult?.success) {
                        handleErrorApi(changePasswordResult);
                        setIsLoading(false)
                        return;
                      }
                      showToastSuccess(getStringsBasedLang("success"))
                      navigate('/login')
                    })
                    .catch((error) => {
                        setIsLoading(false)
                      if (error?.response) {
                        handleErrorApi(error?.response.data);
                      }
                    });
                
            } else {
                showToastError(getStringsBasedLang("confirmPass_notSame"))
            }
        } else {
            showToastError(getStringsBasedLang("confirmPass_validPass"))
        }
    }

    return (
        <Layout>
            <div className={styles.container}>
                <div className="gradient_blue_background" />
                <span className={styles.title}>{getStringsBasedLang("general_changePass")}</span>
                <span className={styles.subTitle}>{getStringsBasedLang("changePass_subTitle")}</span>
                <div className={styles.input_email_container}>
                    <LoginCustomInput
                        onChange={passOnchangeHandler}
                        isPassword={true}
                        icon="passowrd"
                        placeholder={getStringsBasedLang("changePass_oldPass")}
                        color={!passHelperText ? DEFAULT_COLOR : "red"}
                        enterPressed={(e) => enterKeyHadnler(e)}
                    />
                    <div style={!passHelperText ? { visibility: "hidden" } : { visibility: "visible", textAlign: "right" }}  >
                        <span className={styles.inputError_container}>{passHelperText}</span>
                    </div>
                </div>
                <div className={styles.input_email_container}>
                    <LoginCustomInput
                        onChange={newPassOnchangeHandler}
                        isPassword={true}
                        icon="passowrd"
                        placeholder={getStringsBasedLang("changePass_newPass")}
                        color={!newPassHelperText ? DEFAULT_COLOR : "red"}
                        enterPressed={(e) => enterKeyHadnler(e)}
                    />
                    <div style={!newPassHelperText ? { visibility: "hidden" } : { visibility: "visible", textAlign: "right" }}  >
                        <span className={styles.inputError_container}>{newPassHelperText}</span>
                    </div>
                </div>
                <div className={styles.input_email_container}>
                    <LoginCustomInput
                        onChange={e => setConfirmPassValue(e.target.value)}
                        isPassword={true}
                        icon="passowrd"
                        placeholder={getStringsBasedLang("register_confirmPasswrod")}
                        color={DEFAULT_COLOR}
                        enterPressed={(e) => enterKeyHadnler(e)}
                    />

                </div>
                <div className={`${styles.submit_btn_container} flex flex_center`}>
                    {
                        /*  isLoading ?
                             <div className={styles.progress_container}>
                                 <CircularProgress />
                             </div>
                             : */
                        <div onClick={() => confirmHandler()} className={styles.confirm_btn}>{getStringsBasedLang("general_confirm")}</div>
                    }
                </div>
            </div>
        </Layout>
    )
}
